import * as React from 'react'
import { SVG_TYPES } from 'shared/consts'
import { string } from 'prop-types'
import './Svg.scss'

const Svg = ({ type, className }) => {
  switch (type) {
    case SVG_TYPES.CHEVRON_DOWN: {
      return (
        <svg className={`svg svg--chevron-down ${className}`} viewBox="0 0 28 16.829">
          <path
            className="a"
            d="M702.258,46.5,689.672,59.086,677.086,46.5"
            transform="translate(-675.672 -45.086)"
          />
        </svg>
      )
    }
    case SVG_TYPES.HOME: {
      return (
        <svg className={`svg svg--home ${className}`} width="20" height="17" viewBox="0 0 20 17">
          <path
            className="a"
            d="M10,20V14h4v6h5V12h3L12,3,2,12H5v8Z"
            transform="translate(-2 -3)"
          />
        </svg>
      )
    }
    case SVG_TYPES.USERS: {
      return (
        <svg
          className={`svg svg--users ${className}`}
          width="24"
          height="14.5"
          viewBox="0 0 24 14.5"
        >
          <path
            className="a"
            d="M12,5.5A3.5,3.5,0,1,1,8.5,9,3.5,3.5,0,0,1,12,5.5M5,8a2.952,2.952,0,0,1,1.53.42,5.536,5.536,0,0,0,1.13,3.96A3,3,0,1,1,5,8M19,8a3,3,0,1,1-2.66,4.38,5.536,5.536,0,0,0,1.13-3.96A2.952,2.952,0,0,1,19,8M5.5,18.25c0-2.07,2.91-3.75,6.5-3.75s6.5,1.68,6.5,3.75V20H5.5V18.25M0,20V18.5c0-1.39,1.89-2.56,4.45-2.9a4.044,4.044,0,0,0-.95,2.65V20H0m24,0H20.5V18.25a4.044,4.044,0,0,0-.95-2.65c2.56.34,4.45,1.51,4.45,2.9Z"
            transform="translate(0 -5.5)"
          />
        </svg>
      )
    }
    case SVG_TYPES.PREACHER: {
      return (
        <svg
          className={`svg svg--preacher ${className}`}
          width="16"
          height="18"
          viewBox="0 0 16 18"
        >
          <path
            className="a"
            d="M12,3A4,4,0,1,1,8,7a4,4,0,0,1,4-4m4,10.54a11.391,11.391,0,0,1-2.19,6.29L13,15l.94-1.88A17.271,17.271,0,0,0,12,13a17.271,17.271,0,0,0-1.94.12L11,15l-.81,4.83A11.391,11.391,0,0,1,8,13.54c-2.39.7-4,1.96-4,3.46v4H20V17C20,15.5,18.4,14.24,16,13.54Z"
            transform="translate(-4 -3)"
          />
        </svg>
      )
    }
    case SVG_TYPES.LOCATION: {
      return (
        <svg
          className={`svg svg--location ${className}`}
          width="14"
          height="20"
          viewBox="0 0 14 20"
        >
          <path
            className="a"
            d="M12,11.5A2.5,2.5,0,1,1,14.5,9,2.5,2.5,0,0,1,12,11.5M12,2A7,7,0,0,0,5,9c0,5.25,7,13,7,13s7-7.75,7-13A7,7,0,0,0,12,2Z"
            transform="translate(-5 -2)"
          />
        </svg>
      )
    }
    case SVG_TYPES.RECORDING: {
      return (
        <svg
          className={`svg svg--recording ${className}`}
          width="14"
          height="19"
          viewBox="0 0 14 19"
        >
          <path
            className="a"
            d="M12,2a3,3,0,0,1,3,3v6a3,3,0,1,1-6,0V5a3,3,0,0,1,3-3m7,9a7.005,7.005,0,0,1-6,6.93V21H11V17.93A7.005,7.005,0,0,1,5,11H7a5,5,0,0,0,10,0Z"
            transform="translate(-5 -2)"
          />
        </svg>
      )
    }
    case SVG_TYPES.DOTS: {
      return (
        <svg
          className={`svg svg--dots ${className}`}
          width="20"
          height="4.353"
          viewBox="0 0 20 4.353"
        >
          <g transform="translate(-8 -39.295)">
            <g transform="translate(8 39.295)">
              <path
                className="a"
                d="M72.767,39.295a2.176,2.176,0,1,0,2.176,2.176A2.179,2.179,0,0,0,72.767,39.295Z"
                transform="translate(-54.943 -39.295)"
              />
              <path
                className="a"
                d="M41.473,39.295a2.176,2.176,0,1,0,2.176,2.176A2.179,2.179,0,0,0,41.473,39.295Z"
                transform="translate(-31.473 -39.295)"
              />
              <path
                className="a"
                d="M10.176,39.295a2.176,2.176,0,1,0,2.176,2.176A2.179,2.179,0,0,0,10.176,39.295Z"
                transform="translate(-8 -39.295)"
              />
            </g>
          </g>
        </svg>
      )
    }
    case SVG_TYPES.STATUS_PENDING: {
      return (
        <svg
          className={`svg svg--status-pending ${className}`}
          width="13.183"
          height="12"
          viewBox="0 0 13.183 12"
        >
          <path
            className="a"
            d="M-6853.152-1476.959a5.894,5.894,0,0,1-4.142,1.69,5.68,5.68,0,0,1-4.14-1.69,5.567,5.567,0,0,1-1.605-3.211l1.69-.255a4.575,4.575,0,0,0,1.181,2.282,4.236,4.236,0,0,0,5.917,0l-1.774-1.774,5.407-.592-.676,5.409Zm-10.057-10.141,1.86,1.859a5.967,5.967,0,0,1,8.364,0,5.568,5.568,0,0,1,1.606,3.211l-1.689.255a4.563,4.563,0,0,0-1.184-2.282,4.237,4.237,0,0,0-5.917,0l1.777,1.775-5.41.592Z"
            transform="translate(6863.801 1487.101)"
          />
        </svg>
      )
    }
    case SVG_TYPES.STATUS_SUCCESS: {
      return (
        <svg
          className={`svg svg--status-success ${className}`}
          width="13.88"
          height="10.716"
          viewBox="0 0 13.88 10.716"
        >
          <rect
            className="a"
            width="4.995"
            height="2.159"
            transform="translate(1.527 4.485) rotate(45)"
          />
          <rect
            className="a"
            width="12.995"
            height="2.159"
            transform="translate(13.88 1.527) rotate(135)"
          />
        </svg>
      )
    }
    case SVG_TYPES.PLUS: {
      return (
        <svg className={`svg svg--plus ${className}`} width="16" height="16" viewBox="0 0 16 16">
          <path className="a" d="M20,14H14v6H10V14H4V10h6V4h4v6h6Z" transform="translate(-4 -4)" />
        </svg>
      )
    }
    case SVG_TYPES.PLAY: {
      return (
        // <svg
        //   className={`svg svg--play ${className}`}
        //   width="16.704"
        //   height="16.704"
        //   viewBox="0 0 16.704 16.704"
        // >
        //   <path
        //     className="a"
        //     d="M0,1.837,12,0,9.786,11.623Z"
        //     transform="translate(8.219) rotate(45)"
        //   />
        // </svg>
        <svg
          width="14"
          height="16"
          viewBox="0 0 14 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`svg svg--play ${className}`}
        >
          <path
            d="M12.1199 5.40029L4.87988 1.22029C3.95293 0.685107 2.81105 0.684335 1.88337 1.21826C0.955696 1.75219 0.382762 2.73994 0.379883 3.81029V12.1903C0.382762 13.2606 0.955696 14.2484 1.88337 14.7823C2.81105 15.3162 3.95293 15.3155 4.87988 14.7803L12.1199 10.6003C13.05 10.0649 13.6232 9.07346 13.6232 8.00029C13.6232 6.92712 13.05 5.93568 12.1199 5.40029Z"
            fill="#17181D"
          />
        </svg>
      )
    }
    case SVG_TYPES.TIME_BACK: {
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`svg svg--time-back ${className}`}
        >
          <path
            d="M24.1163 7.26082C24.5936 6.98291 25.2058 7.14451 25.4837 7.62177C25.7616 8.09904 25.6 8.71123 25.1228 8.98915L24.1163 7.26082ZM20 10.815L19.1667 11.3679C19.0145 11.1384 18.9636 10.8564 19.0261 10.5882C19.0885 10.32 19.2588 10.0894 19.4968 9.95086L20 10.815ZM23.605 14.4395C23.9103 14.8997 23.7848 15.5203 23.3246 15.8256C22.8644 16.131 22.2438 16.0054 21.9385 15.5452L23.605 14.4395ZM12.1728 12.82C12.5826 12.4498 13.2149 12.4818 13.5852 12.8915C13.9555 13.3013 13.9235 13.9336 13.5138 14.3039L12.1728 12.82ZM25.1228 8.98915L20.5032 11.6792L19.4968 9.95086L24.1163 7.26082L25.1228 8.98915ZM20.8333 10.2621L23.605 14.4395L21.9385 15.5452L19.1667 11.3679L20.8333 10.2621ZM10.375 21.345C10.375 26.5998 14.6758 30.875 20 30.875V32.875C13.5882 32.875 8.375 27.7213 8.375 21.345H10.375ZM20 30.875C25.3242 30.875 29.625 26.5998 29.625 21.345H31.625C31.625 27.7213 26.4118 32.875 20 32.875V30.875ZM29.625 21.345C29.625 16.0902 25.3242 11.815 20 11.815V9.81502C26.4118 9.81502 31.625 14.9687 31.625 21.345H29.625ZM13.5138 14.3039C11.5825 16.0492 10.375 18.5577 10.375 21.345H8.375C8.375 17.9656 9.84201 14.9263 12.1728 12.82L13.5138 14.3039Z"
            fill="#58545B"
          />
          <path
            d="M15.44 20.704H16.536C16.576 20.336 16.808 19.984 17.352 19.984C17.864 19.984 18.144 20.256 18.144 20.712C18.144 21.288 17.664 21.472 17.008 21.472H16.776V22.392H17.008C17.84 22.392 18.256 22.632 18.256 23.288C18.256 23.752 17.968 24.104 17.408 24.104C16.808 24.104 16.472 23.744 16.448 23.24H15.36C15.408 24.464 16.28 25.04 17.432 25.04C18.656 25.04 19.328 24.336 19.328 23.384C19.328 22.592 18.936 22.112 18.344 21.928V21.896C18.768 21.752 19.224 21.304 19.224 20.576C19.224 19.712 18.584 19.032 17.384 19.032C16.264 19.032 15.496 19.624 15.44 20.704ZM20.2131 22.008C20.2131 23.712 20.7251 24.984 22.3731 24.984C24.0211 24.984 24.5331 23.712 24.5331 22.008C24.5331 20.32 24.0211 19.056 22.3731 19.056C20.7251 19.056 20.2131 20.32 20.2131 22.008ZM23.4291 22.008C23.4291 23.048 23.3171 23.944 22.3731 23.944C21.4291 23.944 21.3171 23.048 21.3171 22.008C21.3171 21.008 21.4291 20.096 22.3731 20.096C23.3171 20.096 23.4291 21.008 23.4291 22.008Z"
            fill="#58545B"
          />
        </svg>
      )
    }
    case SVG_TYPES.TIME_FORWARD: {
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`svg svg--time-forward ${className}`}
        >
          <path
            d="M15.8837 7.26082C15.4064 6.98291 14.7942 7.14451 14.5163 7.62177C14.2384 8.09904 14.4 8.71123 14.8772 8.98915L15.8837 7.26082ZM20 10.815L20.8333 11.3679C20.9855 11.1384 21.0364 10.8564 20.9739 10.5882C20.9115 10.32 20.7412 10.0894 20.5032 9.95086L20 10.815ZM16.395 14.4395C16.0897 14.8997 16.2152 15.5203 16.6754 15.8256C17.1356 16.131 17.7562 16.0054 18.0615 15.5452L16.395 14.4395ZM27.8272 12.82C27.4174 12.4498 26.7851 12.4818 26.4148 12.8915C26.0445 13.3013 26.0765 13.9336 26.4862 14.3039L27.8272 12.82ZM14.8772 8.98915L19.4968 11.6792L20.5032 9.95086L15.8837 7.26082L14.8772 8.98915ZM19.1667 10.2621L16.395 14.4395L18.0615 15.5452L20.8333 11.3679L19.1667 10.2621ZM29.625 21.345C29.625 26.5998 25.3242 30.875 20 30.875V32.875C26.4118 32.875 31.625 27.7213 31.625 21.345H29.625ZM20 30.875C14.6758 30.875 10.375 26.5998 10.375 21.345H8.375C8.375 27.7213 13.5882 32.875 20 32.875V30.875ZM10.375 21.345C10.375 16.0902 14.6758 11.815 20 11.815V9.81502C13.5882 9.81502 8.375 14.9687 8.375 21.345H10.375ZM26.4862 14.3039C28.4175 16.0492 29.625 18.5577 29.625 21.345H31.625C31.625 17.9656 30.158 14.9263 27.8272 12.82L26.4862 14.3039Z"
            fill="#58545B"
          />
          <path
            d="M15.44 20.704H16.536C16.576 20.336 16.808 19.984 17.352 19.984C17.864 19.984 18.144 20.256 18.144 20.712C18.144 21.288 17.664 21.472 17.008 21.472H16.776V22.392H17.008C17.84 22.392 18.256 22.632 18.256 23.288C18.256 23.752 17.968 24.104 17.408 24.104C16.808 24.104 16.472 23.744 16.448 23.24H15.36C15.408 24.464 16.28 25.04 17.432 25.04C18.656 25.04 19.328 24.336 19.328 23.384C19.328 22.592 18.936 22.112 18.344 21.928V21.896C18.768 21.752 19.224 21.304 19.224 20.576C19.224 19.712 18.584 19.032 17.384 19.032C16.264 19.032 15.496 19.624 15.44 20.704ZM20.2131 22.008C20.2131 23.712 20.7251 24.984 22.3731 24.984C24.0211 24.984 24.5331 23.712 24.5331 22.008C24.5331 20.32 24.0211 19.056 22.3731 19.056C20.7251 19.056 20.2131 20.32 20.2131 22.008ZM23.4291 22.008C23.4291 23.048 23.3171 23.944 22.3731 23.944C21.4291 23.944 21.3171 23.048 21.3171 22.008C21.3171 21.008 21.4291 20.096 22.3731 20.096C23.3171 20.096 23.4291 21.008 23.4291 22.008Z"
            fill="#58545B"
          />
        </svg>
      )
    }
    case SVG_TYPES.DOWNLOAD: {
      return (
        <svg
          width="22"
          height="19"
          viewBox="0 0 22 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`svg svg--download ${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3104 13.54L6.58037 9.82C6.42221 9.66239 6.33331 9.44829 6.33331 9.225C6.33331 9.00171 6.42221 8.78761 6.58037 8.63C6.913 8.31126 7.43773 8.31126 7.77037 8.63L10.0604 10.93V0.84C10.0604 0.376081 10.4364 0 10.9004 0C11.3643 0 11.7404 0.376081 11.7404 0.84V10.93L14.0304 8.63C14.363 8.31126 14.8877 8.31126 15.2204 8.63C15.3785 8.78761 15.4674 9.00171 15.4674 9.225C15.4674 9.44829 15.3785 9.66239 15.2204 9.82L11.4904 13.54C11.3364 13.7009 11.123 13.7913 10.9004 13.79C10.6772 13.7937 10.4629 13.7029 10.3104 13.54ZM16.1204 5.42H17.3304C19.8466 5.47468 21.845 7.55356 21.8004 10.07V13.88C21.845 16.3964 19.8466 18.4753 17.3304 18.53L4.47038 18.45C1.95413 18.3953 -0.0442775 16.3164 0.000374881 13.8V9.99C-0.0291336 8.77617 0.425615 7.60049 1.26425 6.72245C2.10289 5.84442 3.25647 5.33621 4.47038 5.31H5.68038C6.14429 5.31 6.52037 5.68608 6.52037 6.15C6.52037 6.61392 6.14429 6.99 5.68038 6.99H4.47038C3.70103 7.01337 2.97305 7.34373 2.44888 7.90736C1.9247 8.47099 1.64795 9.22098 1.68037 9.99V13.77C1.64795 14.539 1.9247 15.289 2.44888 15.8526C2.97305 16.4163 3.70103 16.7466 4.47038 16.77L17.3304 16.91C18.0997 16.8866 18.8277 16.5563 19.3519 15.9926C19.876 15.429 20.1528 14.679 20.1204 13.91V10.1C20.1528 9.33098 19.876 8.58099 19.3519 8.01736C18.8277 7.45373 18.0997 7.12337 17.3304 7.1H16.1204C15.6565 7.1 15.2804 6.72392 15.2804 6.26C15.2804 5.79608 15.6565 5.42 16.1204 5.42Z"
            fill="#353535"
          />
        </svg>
      )
    }
    case SVG_TYPES.HEART: {
      return (
        <svg
          width="21"
          height="19"
          viewBox="0 0 21 19"
          fill="none"
          className={`svg svg--heart ${className}`}
        >
          <path
            d="M10.2909 18.675L8.84086 17.355C3.69086 12.685 0.290862 9.59504 0.290862 5.82504C0.282826 5.10054 0.4196 4.38173 0.693155 3.71081C0.966711 3.03989 1.37154 2.43038 1.88387 1.91805C2.3962 1.40571 3.00571 1.00089 3.67663 0.727335C4.34755 0.45378 5.06636 0.317006 5.79086 0.325042C6.64568 0.332007 7.48919 0.521128 8.26515 0.879795C9.04112 1.23846 9.7317 1.75843 10.2909 2.40504C10.85 1.75843 11.5406 1.23846 12.3166 0.879795C13.0925 0.521128 13.936 0.332007 14.7909 0.325042C15.5154 0.317006 16.2342 0.45378 16.9051 0.727335C17.576 1.00089 18.1855 1.40571 18.6979 1.91805C19.2102 2.43038 19.615 3.03989 19.8886 3.71081C20.1621 4.38173 20.2989 5.10054 20.2909 5.82504C20.2909 9.59504 16.8909 12.685 11.7409 17.355L10.2909 18.675Z"
            fill="#43425D"
          />
        </svg>
      )
    }
    case SVG_TYPES.PAUSE: {
      return (
        // <svg
        //   width="10"
        //   height="14"
        //   viewBox="0 0 10 14"
        //   fill="none"
        //   className={`svg svg--pause ${className}`}
        // >
        //   <path
        //     d="M4.62665 2.77979C4.62665 1.67522 3.74051 0.779785 2.6474 0.779785C1.55429 0.779785 0.668152 1.67522 0.668152 2.77979V11.7798C0.668152 12.8844 1.55429 13.7798 2.6474 13.7798C3.74051 13.7798 4.62665 12.8844 4.62665 11.7798V2.77979Z"
        //     fill="#3B86FF"
        //   />
        //   <path
        //     d="M9.93103 2.77979C9.93103 1.67522 9.04489 0.779785 7.95178 0.779785C6.85867 0.779785 5.97253 1.67522 5.97253 2.77979V11.7798C5.97253 12.8844 6.85867 13.7798 7.95178 13.7798C9.04489 13.7798 9.93103 12.8844 9.93103 11.7798V2.77979Z"
        //     fill="#3B86FF"
        //   />
        // </svg>
        <svg
          width="12"
          height="14"
          viewBox="0 0 12 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`svg svg--pause ${className}`}
        >
          <rect x="0.315674" y="0.0527344" width="4.26316" height="13.8947" rx="1" fill="#383A45" />
          <rect x="7.4209" y="0.0527344" width="4.26316" height="13.8947" rx="1" fill="#383A45" />
        </svg>
      )
    }
    case SVG_TYPES.DUPLICATE: {
      return (
        <svg
          className={`svg svg--duplicate ${className}`}
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="3" width="10" height="1.5" rx="0.75" fill="#666495" />
          <mask id="path-2-inside-1_307_2" fill="white">
            <rect y="3" width="10" height="11" rx="1" />
          </mask>
          <rect
            y="3"
            width="10"
            height="11"
            rx="1"
            stroke="#666495"
            strokeWidth="3"
            mask="url(#path-2-inside-1_307_2)"
          />
          <path
            d="M12.25 -3.27835e-08C12.6642 -1.46777e-08 13 0.335786 13 0.75L13 9.25C13 9.66421 12.6642 10 12.25 10V10C11.8358 10 11.5 9.66421 11.5 9.25L11.5 0.75C11.5 0.335786 11.8358 -5.08894e-08 12.25 -3.27835e-08V-3.27835e-08Z"
            fill="#666495"
          />
        </svg>
      )
    }
    case SVG_TYPES.EXCLAMATION_MARK: {
      return (
        <svg
          className={`svg svg--exclamation-mark ${className}`}
          width="4"
          height="18"
          viewBox="0 0 4 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="4" height="12" rx="1" fill="#FF6565" />
          <rect y="14" width="4" height="4" rx="1" fill="#FF6565" />
        </svg>
      )
    }

    case SVG_TYPES.LOGO: {
      return (
        <svg
          width="26"
          height="25"
          viewBox="0 0 26 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.28 13.8849L7.33777 13.8235L7.39555 13.762L7.51111 13.6392L7.68444 13.5163C7.79999 13.3934 7.97334 13.332 8.14667 13.2705L8.37778 13.1477L8.66667 13.0248C8.84 12.9633 9.01333 12.9019 9.24444 12.8405L9.82222 12.7176L10.4 12.5947L10.9778 12.5333C11.3822 12.4719 11.7289 12.4719 12.0178 12.4719H12.7111H13.2889H14.04C14.3289 12.4719 14.6756 12.5333 15.08 12.5333L15.6578 12.5947L16.2356 12.7176L16.8133 12.8405C16.9867 12.9019 17.2178 12.9633 17.3911 13.0248L17.68 13.1477L17.9689 13.2705C18.1422 13.332 18.2578 13.3934 18.4311 13.5163L18.6044 13.6392L18.7778 13.762L18.8356 13.8235L18.8933 13.8849L19.0089 14.0078L19.0667 13.9464C19.24 13.7006 19.3556 13.4548 19.5867 13.2091L19.4711 13.0862L19.1822 12.8405C19.0667 12.779 18.9511 12.6562 18.7778 12.5947C18.6044 12.5333 18.4889 12.4104 18.3155 12.349L18.0267 12.2261L17.7378 12.1647C17.5644 12.1032 17.3333 12.0418 17.1022 11.9803L16.4667 11.8575L15.8889 11.7346L15.2533 11.6732C14.8489 11.6117 14.4444 11.6117 14.0978 11.6117H13.2889H12.7111H11.9022C11.5556 11.6117 11.2089 11.6732 10.7467 11.6732L10.1111 11.7346L9.47555 11.8575L8.83999 11.9803C8.60888 12.0418 8.43554 12.1032 8.20443 12.1647L7.91555 12.2261L7.62666 12.349C7.45332 12.4104 7.28 12.4718 7.16444 12.5947C7.04889 12.6562 6.93333 12.7176 6.81777 12.8405L6.64444 12.9633L6.4711 13.1477C6.64443 13.4549 6.87555 13.8235 7.04888 14.1307L7.28 13.8849ZM7.28 13.4549L6.87555 13.2705L6.99112 12.8405L7.39555 13.0248L7.28 13.4549ZM9.82222 12.5947L9.53333 12.4719L9.47555 12.2261L9.70666 11.9803L9.99555 12.1647L10.0533 12.349L9.82222 12.5947ZM12.9422 12.349L12.6533 11.9803L12.9422 11.6732L13.2889 11.9803L12.9422 12.349ZM16.2933 12.4719L16.0622 12.5333L15.8889 12.349L15.9467 12.0418L16.2356 11.9803L16.4089 12.2261L16.2933 12.4719ZM18.6044 13.5163L18.4889 13.0862L18.8933 12.9019L19.0089 13.332L18.6044 13.5163ZM10.5155 9.21565L10.2844 8.84703L10.8622 6.75814H12.7111L13.2311 4.91501H15.5422L15.7733 5.2222L15.3111 6.75814H16.9867L17.2178 7.12677L16.64 9.21565H14.6756L14.4444 10.0758C14.3867 10.0143 14.3289 9.89146 14.2711 9.83002C14.2711 9.64571 14.3289 9.39996 14.4444 9.27709L14.56 9.15422L14.4444 8.9699L13.1733 7.43396L13 7.24965L12.8844 7.43396L11.5556 8.9699L11.44 9.09278L11.4978 9.15422L10.5155 9.21565ZM7.22222 14.1921L7.16444 14.2535V14.315V14.3764C7.28 14.5607 7.33777 14.6836 7.33777 14.745C7.45332 14.9908 7.62667 15.728 10.1689 16.0352L9.88 16.9568L10.0533 17.264H12.3067L12.5955 16.1581H12.9422C18.2578 16.1581 18.4889 14.9908 18.6622 14.6836C18.72 14.6222 18.7778 14.4993 18.8933 14.315L18.8356 14.1921L18.72 14.0692L18.5467 13.9464L18.3733 13.8235C18.2578 13.762 18.0844 13.6392 17.9689 13.5777C17.7956 13.5163 17.6222 13.4549 17.4489 13.3934C17.0444 13.2705 16.6978 13.1477 16.2933 13.0862L15.7155 12.9633L15.1378 12.9019C14.7911 12.8405 14.4444 12.8405 14.0978 12.8405H13.3467H12.7111H11.96C11.6711 12.8405 11.3244 12.9019 10.92 12.9019L10.4 12.9633L9.82222 13.0862C9.41778 13.1477 9.07111 13.2705 8.66667 13.3934C8.49333 13.4549 8.32 13.5163 8.14667 13.5777C7.97334 13.6392 7.85777 13.7006 7.74222 13.8235L7.51111 13.9464L7.33777 14.0692L7.22222 14.1921ZM13 15.8509H12.7111L12.8844 15.2365L13.4044 13.3934H12.9422C12.2489 13.3934 11.4978 13.4548 10.8044 13.5777L10.5155 14.6836L10.2267 15.728C8.66666 15.4823 7.62666 15.1137 7.62666 14.6836C7.62666 14.0692 10.0533 13.2091 13 13.2091C15.9467 13.2091 18.3733 14.1307 18.3733 14.6836C18.3733 15.2365 16.0044 15.8509 13 15.8509ZM6.35556 12.9633C6.24 12.8405 6.18223 12.6562 6.12445 12.5947C5.95111 12.4104 5.72 12.2261 5.43111 12.1647L5.02666 10.383C5.02666 10.383 6.23999 10.5058 6.81777 10.5673C6.70222 10.813 6.70222 11.0588 6.81777 11.3045C6.93333 11.4889 7.28 11.796 8.08889 11.5503C8.89778 11.3045 8.89777 10.2601 8.78221 9.83002H8.72445C8.43556 9.83002 8.20443 9.58428 8.20443 9.27709C8.20443 8.9699 8.43556 8.72415 8.72445 8.72415C9.01334 8.72415 9.24444 8.9699 9.24444 9.27709C9.24444 9.4614 9.18667 9.64572 9.01334 9.7686C9.36 10.2601 9.88 10.6287 10.4578 10.6902C11.0356 10.7516 11.6133 10.4444 11.8444 9.89146C11.8444 9.64571 11.7867 9.33854 11.6133 9.15422L12.8844 7.6797L14.1556 9.15422C13.9822 9.33854 13.9244 9.64571 13.9244 9.89146C14.1556 10.4444 14.7333 10.7516 15.3111 10.6902C15.8889 10.6287 16.4089 10.3215 16.7556 9.7686C16.5244 9.58429 16.4667 9.21565 16.64 8.9699C16.8133 8.72415 17.16 8.66272 17.3911 8.84703C17.6222 9.03135 17.68 9.39997 17.5067 9.64572C17.3911 9.76859 17.2178 9.89146 17.0444 9.89146C16.9867 10.3215 16.9867 11.366 17.7378 11.6117C18.4889 11.8575 18.8933 11.6117 19.0089 11.366C19.1244 11.1202 19.1244 10.8745 19.0089 10.6287C19.76 10.5673 20.9733 10.4444 20.9733 10.4444L20.6267 12.2261C20.3378 12.2875 20.1067 12.4104 19.9333 12.6562C19.8756 12.7176 19.8178 12.8405 19.7022 13.0248C19.7022 13.0248 19.7022 12.9633 19.6444 12.9633L19.4711 12.7176L19.4133 12.6562L19.3556 12.5947L19.2978 12.5333L19.1822 12.4719L19.0667 12.4104L18.8356 12.2875C18.6622 12.2261 18.4889 12.1032 18.3155 12.0418C18.1422 11.9803 17.9111 11.9189 17.7378 11.8575C17.3333 11.7346 16.8711 11.6117 16.4667 11.5503L15.8311 11.4274L15.1955 11.366C14.7911 11.3045 14.3867 11.3045 14.04 11.3045C13.6933 11.3045 13.4044 11.3045 13.2311 11.3045H12.6533H11.8444C11.4978 11.3045 11.1511 11.366 10.6889 11.366L10.0533 11.4274L9.41777 11.5503C9.01333 11.6117 8.55112 11.7346 8.14667 11.8575C7.91556 11.9189 7.74223 11.9803 7.56889 12.0418C7.39556 12.1032 7.22221 12.1647 7.04888 12.2875L6.81777 12.4104L6.70223 12.4719L6.64444 12.5333L6.58666 12.5947L6.52888 12.6562L6.4711 12.7176L6.35556 12.9633ZM6.29777 22.8548L10.1111 20.9502L7.33777 19.4757L2.48444 20.4587L6.29777 22.8548ZM2.6 18.8614H6.4711L4.68 16.4653L0.288889 15.298L2.6 18.8614ZM0.635559 13.8849L3.92888 15.5437L3.29332 12.779L0 9.89146L0.635559 13.8849ZM0.866667 8.60127L2.88889 11.3045L3.3511 8.78559L1.73333 5.09934L0.866667 8.60127ZM2.83111 4.42352L3.58221 7.43396L4.85333 5.59083V1.90457L2.83111 4.42352ZM5.72 1.29019L5.25778 4.11633L6.99112 3.07188L8.32 0L5.72 1.29019ZM14.2711 24.6365L13 22.9163L11.7289 24.6365L7.16444 24.2679L11.2667 21.0117H14.7911L18.8933 24.2679L14.2711 24.6365ZM19.7022 22.8548L15.8889 20.9502L18.6622 19.4757L23.5155 20.3973L19.7022 22.8548ZM23.4 18.8614H19.5289L21.3778 16.4653L25.7689 15.298L23.4 18.8614ZM25.3644 13.8849L22.0711 15.5437L22.7067 12.779L26 9.89146L25.3644 13.8849ZM25.1333 8.60127L23.1111 11.3045L22.6489 8.78559L24.2667 5.09934L25.1333 8.60127ZM23.1689 4.42352L22.4178 7.43396L21.1467 5.59083V1.90457L23.1689 4.42352ZM20.28 1.29019L20.7422 4.11633L19.0089 3.13332L17.68 0.0614414L20.28 1.29019Z"
            fill="#353535"
          />
        </svg>
      )
    }
    case SVG_TYPES.MAGNIFIER: {
      return (
        <svg
          className={`svg svg--magnifier ${className}`}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="d"
            d="M18.0435 19.4578C18.4344 19.8479 19.0676 19.8473 19.4578 19.4565C19.8479 19.0656 19.8473 18.4324 19.4565 18.0422L18.0435 19.4578ZM11.2212 16.1923C8.47566 16.1923 6.25 13.9666 6.25 11.2212H4.25C4.25 15.0712 7.37109 18.1923 11.2212 18.1923V16.1923ZM6.25 11.2212C6.25 8.47566 8.47566 6.25 11.2212 6.25V4.25C7.37109 4.25 4.25 7.37109 4.25 11.2212H6.25ZM11.2212 6.25C13.9666 6.25 16.1923 8.47566 16.1923 11.2212H18.1923C18.1923 7.37109 15.0712 4.25 11.2212 4.25V6.25ZM16.1923 11.2212C16.1923 12.5955 15.6359 13.8379 14.7338 14.7388L16.147 16.1541C17.4095 14.8933 18.1923 13.1477 18.1923 11.2212H16.1923ZM14.7338 14.7388C13.8333 15.638 12.5929 16.1923 11.2212 16.1923V18.1923C13.1441 18.1923 14.8868 17.4124 16.147 16.1541L14.7338 14.7388ZM14.7339 16.1542L18.0435 19.4578L19.4565 18.0422L16.1468 14.7387L14.7339 16.1542Z"
            fill="#C8C8C8"
          />
        </svg>
      )
    }
    case SVG_TYPES.CHEVRON_RIGHT: {
      return (
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.84642 9.26319C2.84642 9.07792 2.91685 8.89266 3.05822 8.7513L6.40646 5.40353L3.05822 2.05576C2.77598 1.77304 2.77598 1.31471 3.05822 1.03199C3.34093 0.749753 3.79927 0.749753 4.08199 1.03199L7.94164 4.89164C8.22388 5.17436 8.22388 5.6327 7.94164 5.91542L4.08199 9.77507C3.79927 10.0573 3.34093 10.0573 3.05822 9.77507C2.91685 9.63371 2.84642 9.44845 2.84642 9.26319Z"
            fill="white"
          />
        </svg>
      )
    }
    case SVG_TYPES.THIN_CHEVRON_RIGHT: {
      return (
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.33312 11.8339C1.46583 11.8345 1.5932 11.7816 1.68646 11.6872L7.01979 6.35388C7.21476 6.15867 7.21476 5.84243 7.01979 5.64722L1.68646 0.313882C1.48945 0.13031 1.18245 0.135727 0.992042 0.326135C0.801634 0.516543 0.796217 0.823543 0.979789 1.02055L5.95979 6.00055L0.979789 10.9805C0.784821 11.1758 0.784821 11.492 0.979789 11.6872C1.07305 11.7816 1.20041 11.8345 1.33312 11.8339Z"
            fill="#353535"
          />
        </svg>
      )
    }
    case SVG_TYPES.EXIT: {
      return (
        <svg
          className={`svg svg--exit ${className}`}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.7188 14.3906L9.32501 8.00037L15.7188 1.65714C16.0392 1.28603 16.0219 0.729108 15.679 0.378943C15.3361 0.0287773 14.7832 0.00341392 14.4101 0.320731L7.99765 6.6169L1.69734 0.273674C1.33275 -0.0912247 0.743918 -0.0912247 0.379325 0.273674C0.202363 0.450387 0.102824 0.690937 0.102824 0.941878C0.102824 1.19282 0.202363 1.43337 0.379325 1.61008L6.67028 7.9439L0.276501 14.2777C0.0995389 14.4544 0 14.695 0 14.9459C0 15.1969 0.0995389 15.4374 0.276501 15.6141C0.452909 15.7903 0.69172 15.8885 0.940183 15.887C1.18409 15.8885 1.41891 15.794 1.59452 15.6235L7.99765 9.27089L14.4101 15.7271C14.5865 15.9032 14.8253 16.0014 15.0738 16C15.319 15.9989 15.554 15.9009 15.7281 15.7271C15.9039 15.5491 16.0017 15.3078 16 15.0569C15.9982 14.8059 15.897 14.5661 15.7188 14.3906Z"
            fill="#C4CAD1"
          />
        </svg>
      )
    }
    case SVG_TYPES.FILTERS: {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 9.375C10.5 10.2034 9.82843 10.875 9 10.875C8.17157 10.875 7.5 10.2034 7.5 9.375M10.5 9.375C10.5 8.54657 9.82843 7.875 9 7.875C8.17157 7.875 7.5 8.54657 7.5 9.375M10.5 9.375H19.125M7.5 9.375H4.875M13.5 15.375C13.5 14.5466 14.1716 13.875 15 13.875C15.8284 13.875 16.5 14.5466 16.5 15.375M13.5 15.375C13.5 16.2034 14.1716 16.875 15 16.875C15.8284 16.875 16.5 16.2034 16.5 15.375M13.5 15.375L4.875 15.375M16.5 15.375H19.125"
            stroke="#353535"
            strokeLinecap="round"
          />
        </svg>
      )
    }
    case SVG_TYPES.NO_RESULTS: {
      return (
        <svg
          width="210"
          height="151"
          viewBox="0 0 210 151"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1200_8075)">
            <path
              d="M200.939 150.667C187.692 150.667 8.60287 150.281 8.60287 150.26C8.52868 150.086 -14.1316 122.339 14.4025 93.3286C28.5412 78.9543 1.41864 60.3318 14.4025 44.342C36.6435 16.9526 58.6494 32.378 76.9813 24.6746C80.2208 23.3145 83.471 21.1266 86.7248 17.7679C88.5564 15.8791 90.5632 14.2279 92.7121 12.8017C93.042 12.582 93.3745 12.3677 93.7106 12.1596C94.9969 11.3621 96.3315 10.6415 97.7054 9.99312C98.6288 9.55821 99.5683 9.15634 100.527 8.78663C102.046 8.1999 103.608 7.69355 105.203 7.26578C107.468 6.65763 109.799 6.20486 112.177 5.89855C113.214 5.7637 114.259 5.65832 115.313 5.57884C135.798 4.04014 158.85 12.6937 170.746 25.3417C173.141 27.8887 184.032 41.0663 175.447 59.1798C170.027 70.616 192.735 81.5379 200.805 94.5976C221.32 127.8 201.125 150.234 200.938 150.667H200.939Z"
              fill="#EEEAEC"
            />
            <g opacity="0.8">
              <path
                d="M154.59 73.4711C154.043 74.9731 153.372 76.3966 152.592 77.7308C150.719 80.9333 148.222 83.6258 145.317 85.7074C138.567 90.5459 129.62 92.0811 121.223 89.0313C111.233 85.4038 104.817 76.3056 104.134 66.3527C104.043 65.0408 104.052 63.7146 104.167 62.384C104.357 60.1496 104.843 57.9027 105.646 55.6961C106.295 53.9109 107.12 52.2391 108.094 50.695C108.105 50.6772 108.116 50.6602 108.127 50.6424C110.83 46.3772 114.669 43.0846 119.085 41.0208C120.338 40.435 121.637 39.9482 122.971 39.5669C123.607 39.3847 124.252 39.2267 124.901 39.0945C129.457 38.1577 134.321 38.4301 139.015 40.1349C139.637 40.3608 140.246 40.6082 140.839 40.8761C141.678 41.2521 142.487 41.6691 143.265 42.1228C146.545 44.033 149.289 46.5969 151.393 49.5814H151.394C152.706 51.4398 153.767 53.4608 154.552 55.5889C154.965 56.707 155.302 57.8536 155.559 59.0226C155.719 59.7504 155.848 60.4845 155.945 61.2275C156.179 63.0109 156.227 64.83 156.081 66.659C155.897 68.9335 155.408 71.2233 154.59 73.4728V73.4711Z"
                fill="#CAA8A2"
              />
              <path
                d="M125.786 50.6207C124.247 51.8112 124.655 54.9966 121.991 53.2016C119.327 51.4057 117.656 50.4296 116.901 51.9969C116.146 53.5642 118.507 54.4215 117.885 56.129C117.264 57.8365 116 58.0169 114.668 56.6148C113.335 55.2127 113.296 53.8634 111.138 53.908C108.98 53.9527 108.059 53.0659 108.164 51.4468C108.182 51.1619 108.154 50.9154 108.094 50.6958C108.104 50.6779 108.116 50.6609 108.127 50.6431C110.83 46.3779 114.669 43.0853 119.085 41.0215C120.337 40.4357 121.637 39.949 122.971 39.5676C123.606 39.3855 124.252 39.2274 124.901 39.0952C125.653 39.4006 126.461 40.0204 126.888 41.2635C127.827 43.9989 129.351 43.355 128.057 45.6465C126.762 47.9372 127.295 48.4998 128.708 48.9204C130.121 49.341 131.749 49.9322 131.527 51.0485C131.305 52.1648 127.325 49.4294 125.786 50.6207Z"
                fill="#959196"
              />
              <path
                d="M154.589 73.4709C154.042 74.973 153.372 76.3965 152.591 77.7307C150.719 80.9331 148.221 83.6256 145.316 85.7073C144.592 85.685 143.933 85.4394 143.378 84.9438C140.769 82.6156 144.226 80.1437 146.046 78.9399C147.866 77.737 144.487 77.3378 142.783 74.9936C141.08 72.6493 145.069 69.4719 142.505 69.3004C139.942 69.129 136.824 68.9629 136.302 66.2195C135.78 63.4761 138.477 64.0405 138.005 61.7293C137.533 59.4181 139.763 58.985 142.149 59.6449C144.535 60.304 144.829 58.5474 147.786 59.3449C150.744 60.1424 149.351 63.7788 152.614 64.6879C155.876 65.597 155.467 66.2766 155.467 66.2766C155.698 66.3534 155.902 66.482 156.079 66.6562C155.895 68.9307 155.406 71.2205 154.588 73.47L154.589 73.4709Z"
                fill="#7F7B80"
              />
              <path
                d="M155.946 61.2266C152.84 61.5508 153.05 57.6768 150.413 57.9072C147.753 58.1385 148.891 56.2497 147.575 54.2993C146.258 52.3489 141.82 53.4063 142.722 51.4318C143.623 49.459 146.102 51.0022 147.263 49.5841C148.425 48.165 150.881 49.5171 150.881 49.5171C151.049 49.5144 151.221 49.5359 151.394 49.5814C151.394 49.5814 151.394 49.5805 151.395 49.5814C152.706 51.4398 153.767 53.4599 154.553 55.5889C154.966 56.7069 155.303 57.8536 155.56 59.0226C155.72 59.7504 155.848 60.4845 155.946 61.2275V61.2266Z"
                fill="#959196"
              />
              <path
                d="M136.261 46.1402C136.261 46.1402 138.37 44.6489 136.387 43.262C134.403 41.876 134.164 42.661 132.522 41.8581C130.879 41.0553 129.727 42.1332 130.484 44.0416C131.24 45.95 131.27 49.0962 132.967 48.0415C134.664 46.9868 134.847 45.7875 136.262 46.1402H136.261Z"
                fill="#7F7B80"
              />
            </g>
            <path
              d="M14.517 150.333H23.5989C24.0852 149.92 23.2619 148.983 22.402 148.921C22.0284 148.892 21.5555 148.971 21.0156 149.084C20.8904 147.426 20.1771 139.971 17.4874 140.271C14.4633 140.607 17.4874 143.554 18.3419 145.299C18.9757 146.591 19.6434 148.445 19.9483 149.32C19.7024 149.373 19.4486 149.426 19.1884 149.473C18.788 148.243 17.2961 144.108 15.3992 144.349C13.1725 144.631 14.0673 146.289 15.6459 147.273C16.8035 147.998 18.2257 149.026 18.9015 149.523C18.3294 149.617 17.7314 149.679 17.1253 149.665C15.57 149.628 14.8102 150.085 14.5161 150.332L14.517 150.333Z"
              fill="#A8D29F"
            />
            <path
              d="M159.051 150.333H150.615C150.163 149.95 150.928 149.08 151.727 149.021C152.074 148.995 152.513 149.067 153.015 149.173C153.131 147.632 153.793 140.708 156.292 140.986C159.101 141.298 156.292 144.036 155.498 145.657C154.91 146.857 154.289 148.579 154.005 149.391C154.233 149.441 154.469 149.489 154.71 149.533C155.083 148.391 156.468 144.549 158.23 144.774C160.298 145.036 159.467 146.576 158.001 147.49C156.925 148.163 155.604 149.118 154.977 149.58C155.509 149.667 156.064 149.725 156.626 149.712C158.071 149.678 158.776 150.103 159.049 150.332L159.051 150.333Z"
              fill="#A8D29F"
            />
            <path
              d="M87.4173 94.254L82.9684 147.104C82.9684 147.104 82.5027 150.307 84.8876 150.313C88.8091 150.322 104.408 150.313 104.408 150.313C104.408 150.313 101.457 149.646 101.493 148.146C101.535 146.378 106.692 93.7539 106.692 93.7539L87.4173 94.254Z"
              fill="#848086"
            />
            <path
              d="M105.876 149.376C105.105 149.379 90.0033 149.404 86.1836 149.354C84.5192 149.334 84.2269 147.876 84.2135 146.933C84.2063 146.481 84.2645 146.146 84.2645 146.146L84.3798 144.772L84.6748 141.272L84.9349 138.178L85.2701 134.203L85.5517 130.848L88.7134 93.2941L107.988 92.7939C107.988 92.7939 105.816 114.817 104.28 130.847C104.108 132.633 103.945 134.346 103.794 135.945C103.745 136.455 103.699 136.954 103.652 137.44C103.51 138.956 103.379 140.349 103.266 141.579C103.206 142.227 103.151 142.829 103.101 143.381C102.906 145.543 102.79 146.924 102.789 147.186C102.789 147.339 102.801 147.482 102.826 147.614C103.143 149.298 105.587 149.374 105.876 149.374V149.376Z"
              fill="#B1ABAD"
            />
            <path
              d="M40.6074 65.4946L51.4441 108.984L52.928 114.94L57.9758 135.196H151.75L133.145 65.4946H40.6074Z"
              fill="#B1ABAD"
            />
            <path
              d="M40.6081 65.4946L39.1055 65.9947L55.9795 136.709L57.9765 135.196L40.6081 65.4946Z"
              fill="#848086"
            />
            <path
              d="M55.9805 136.709H149.177L151.751 135.196H57.9774L55.9805 136.709Z"
              fill="#9B9597"
            />
            <path d="M88.706 150.333H108.885V149.375H88.706V150.333Z" fill="#D7DDEE" />
            <path
              d="M103.757 136.708L103.653 137.441L84.6758 141.271L84.9359 138.178L85.0602 136.708H103.757Z"
              fill="#848086"
            />
            <path
              opacity="0.4"
              d="M105.877 149.376C105.106 149.379 90.0046 149.404 86.185 149.355C84.5206 149.334 84.2283 147.876 84.2148 146.933L103.102 143.383C102.906 145.545 102.791 146.925 102.789 147.188C102.789 147.341 102.802 147.484 102.827 147.616C103.143 149.3 105.587 149.376 105.877 149.376H105.877Z"
              fill="#9B9597"
            />
            <path
              d="M40.6074 65.4946H133.145L148.16 121.512H54.5665L40.6074 65.4946Z"
              fill="#CDC4B9"
            />
            <path
              d="M143.795 119.085H57.1506L54.0551 106.763L52.8573 101.995L52.3683 100.051L49.186 87.3873L49.0216 86.7274L47.3392 80.034L46.5866 77.0388L45.9448 74.4838L44.4395 68.4951H129.835L131.488 74.4838L132.192 77.0388L133.019 80.034L138.464 99.7648V99.7657L138.925 101.437L139.14 102.214L142.898 115.836L143.795 119.085Z"
              fill="#848086"
            />
            <path
              d="M131.489 74.4847H45.9458L44.4414 68.4951H129.836L131.489 74.4847Z"
              fill="#656067"
            />
            <path
              d="M47.9742 71.202C47.8714 70.7885 48.1226 70.4536 48.5364 70.4536C48.9503 70.4536 49.3696 70.7885 49.4724 71.202C49.5752 71.6155 49.324 71.9503 48.9101 71.9503C48.4962 71.9503 48.077 71.6155 47.9742 71.202Z"
              fill="#E9F3FE"
            />
            <path
              d="M50.4644 71.202C50.3616 70.7885 50.6128 70.4536 51.0267 70.4536C51.4406 70.4536 51.8598 70.7885 51.9626 71.202C52.0654 71.6155 51.8142 71.9503 51.4003 71.9503C50.9865 71.9503 50.5672 71.6155 50.4644 71.202Z"
              fill="#E9F3FE"
            />
            <path
              d="M53.1461 71.202C53.0433 70.7885 53.2944 70.4536 53.7083 70.4536C54.1222 70.4536 54.5414 70.7885 54.6442 71.202C54.747 71.6155 54.4958 71.9503 54.082 71.9503C53.6681 71.9503 53.2489 71.6155 53.1461 71.202Z"
              fill="#E9F3FE"
            />
            <path
              d="M54.6504 98.0218C54.6504 98.0218 54.8864 97.4913 55.0392 97.2404C55.1921 96.9894 55.8455 96.2536 55.9564 96.4197C56.0672 96.5867 56.5124 97.7074 56.2764 98.0218C56.0404 98.3361 56.2916 98.8818 55.117 99.2131L54.6513 98.0218H54.6504Z"
              fill="#FFB27D"
            />
            <path
              d="M41.5938 94.6729C41.5938 94.6729 47.6088 99.689 49.9535 99.2247C51.7877 98.8612 54.6866 97.9432 54.6866 97.9432C54.6866 97.9432 55.4518 98.6701 55.2355 99.5417C55.2355 99.5417 51.5419 103.014 48.9103 103.036C44.7966 103.071 42.8568 101 42.8568 101L41.5938 94.6737V94.6729Z"
              fill="#ED7D2B"
            />
            <path
              d="M31.0449 147.58C31.0449 147.58 31.2192 150.394 31.7645 150.434C31.8369 150.439 34.5284 150.439 34.5284 150.439L37.9646 150.42C37.9646 150.42 37.9422 149.593 36.9375 149.418C35.9336 149.243 34.2522 148.538 33.6435 147.212C33.0034 145.817 31.0449 147.58 31.0449 147.58Z"
              fill="#113C68"
            />
            <path
              d="M30.8475 147.775C30.8475 147.775 31.8916 148.124 32.7077 148.124C33.6177 148.124 34.4437 147.877 34.4437 147.877C34.4437 147.877 34.6403 145.978 35.7219 141.792C36.2896 139.598 37.0994 136.777 38.2517 133.271C41.4384 123.584 42.4074 117.917 42.4959 117.38C42.5003 117.351 42.5021 117.338 42.5021 117.338L42.4914 117.333L32.6934 113.036C32.6934 113.036 33.9047 126.388 32.3591 131.513C32.1428 132.229 31.9578 133.064 31.7986 133.968C30.8225 139.534 30.8458 147.776 30.8458 147.776L30.8475 147.775Z"
              fill="#2A4E96"
            />
            <path
              d="M35.721 141.791C36.2886 139.597 37.0985 136.776 38.2507 133.27C41.4374 123.583 42.4064 117.916 42.4949 117.379C42.494 117.363 42.4931 117.348 42.4913 117.331L32.6934 113.034C32.6934 113.034 33.9046 126.386 32.359 131.511C32.1427 132.227 35.7201 141.791 35.7201 141.791H35.721Z"
              fill="#233862"
            />
            <path
              d="M38.6973 147.58C38.6973 147.58 38.8716 150.394 39.4168 150.434C39.4893 150.439 42.1808 150.439 42.1808 150.439L45.6169 150.42C45.6169 150.42 45.5946 149.593 44.5898 149.418C43.586 149.243 41.9046 148.538 41.2958 147.212C40.6558 145.817 38.6973 147.58 38.6973 147.58Z"
              fill="#15447C"
            />
            <path
              d="M44.2516 113.35C44.2516 113.35 44.3785 122.001 42.8804 132.625C41.3822 143.248 41.8899 147.757 41.8899 147.757C41.8899 147.757 40.8602 148.09 40.4454 148.124C39.387 148.21 38.3018 147.876 38.3018 147.876C38.3018 147.876 36.1574 137.249 36.7724 131.932C37.3874 126.615 33.8359 113.686 33.8359 113.686L44.2525 113.349L44.2516 113.35Z"
              fill="#2A4E96"
            />
            <path
              d="M37.3056 93.1029L39.2176 94.3558L40.9598 93.8638C41.278 93.4101 41.363 92.5349 41.3674 91.7777C41.3719 91.0257 41.2986 90.3881 41.2986 90.3881L38.7179 89.2504L37.7552 88.8262C37.7579 88.8414 37.8303 89.6156 37.8401 89.729C38.0198 91.7375 37.3047 93.1029 37.3047 93.1029H37.3056Z"
              fill="#FFB27D"
            />
            <path
              d="M44.2966 115.755C41.9162 118.051 32.9075 117.665 32.3524 115.135C31.7982 112.605 32.9576 93.5992 37.0239 92.4052C37.8678 92.1579 42.3792 93.6144 42.3792 93.6144C42.3792 93.6144 43.0872 95.4648 43.5511 97.8197C43.6414 98.2778 43.9042 103.135 44.1009 107.679C44.193 109.804 44.2707 111.861 44.3101 113.367C44.3458 114.778 44.3476 115.705 44.2966 115.755V115.755Z"
              fill="#E3958A"
            />
            <path
              d="M38.0353 89.7647C38.5591 90.6488 40.3952 91.423 41.3686 91.7776C41.3731 91.0256 41.2998 90.388 41.2998 90.388L38.7191 89.2503C38.1488 89.2431 37.8011 89.3699 38.0344 89.7647H38.0353Z"
              fill="#FCA56B"
            />
            <path
              d="M42.2728 90.2307C42.2728 90.2307 38.1153 91.5264 37.3475 88.9277C36.5796 86.329 35.5257 84.7456 38.1475 83.8088C40.7693 82.872 41.581 83.7106 42.0485 84.5161C42.516 85.3216 43.3348 89.8279 42.2728 90.2315V90.2307Z"
              fill="#FFB27D"
            />
            <path
              d="M41.8851 84.2643C41.8851 84.2643 41.6196 87.2891 40.9939 87.1578C40.3682 87.0265 39.679 86.7452 39.7702 87.657C39.8622 88.5688 39.1614 90.1316 38.2586 90.128C36.3224 90.12 34.2191 85.1565 34.7492 84.2152C36.2786 81.4995 44.0957 80.9512 41.8851 84.2643Z"
              fill="#163560"
            />
            <path
              d="M41.273 92.4705C41.2194 92.4482 38.1783 91.0854 37.8226 91.2024C37.4668 91.3194 37.0234 92.4054 37.0234 92.4054L42.3788 93.6145C42.3788 93.6145 41.9568 92.7581 41.273 92.4705Z"
              fill="#ED7D2B"
            />
            <path
              d="M60.2079 107.191L43.1596 123.227C42.8253 123.541 42.4042 123.641 42.2228 123.449L41.6471 122.839C41.4666 122.647 41.5917 122.232 41.926 121.918L58.9744 105.882C59.3087 105.567 59.7297 105.467 59.9112 105.659L60.4868 106.27C60.6674 106.462 60.5423 106.876 60.2079 107.191Z"
              fill="#58545B"
            />
            <path
              d="M50.6406 116.19L43.1596 123.227C42.8253 123.541 42.4042 123.641 42.2228 123.449L41.6471 122.838C41.4666 122.646 41.5917 122.232 41.926 121.917L49.407 114.88L50.6406 116.189V116.19Z"
              fill="#353535"
            />
            <path
              d="M56.289 101.136C56.9433 103.291 58.1554 105.309 59.9155 106.963C65.2905 112.015 73.7476 111.757 78.8044 106.388C83.7941 101.088 83.6091 92.7921 78.437 87.7197C78.3681 87.6518 78.2984 87.584 78.2269 87.5179C72.8528 82.466 64.3966 82.7223 59.3398 88.0921C55.9385 91.7035 54.941 96.709 56.2881 101.136H56.289ZM60.1086 88.8146C63.0513 85.6898 67.2445 84.444 71.1821 85.1254C73.4768 85.5219 75.6829 86.5721 77.5055 88.285C82.4559 92.9377 82.6928 100.719 78.0356 105.665C76.3211 107.486 74.1829 108.668 71.9178 109.204C68.0285 110.124 63.7664 109.137 60.6386 106.197C55.6883 101.543 55.4505 93.762 60.1086 88.8155V88.8146Z"
              fill="#58545B"
            />
            <g opacity="0.5">
              <path
                d="M78.0366 105.665C76.3221 107.486 74.183 108.668 71.9188 109.204C68.0294 110.123 63.7682 109.136 60.6396 106.196C55.6892 101.543 55.4514 93.761 60.1095 88.8144C63.0522 85.6897 67.2455 84.4439 71.1831 85.1253C73.4777 85.5218 75.6847 86.572 77.5065 88.2849C82.4569 92.9376 82.6947 100.719 78.0366 105.665Z"
                fill="#B3CFF9"
              />
            </g>
            <path
              d="M44.3102 113.368C34.9163 106.68 35.6975 97.7563 35.6975 97.7563C39.131 99.6907 42.5376 103.968 44.101 107.679C44.1931 109.804 44.2709 111.861 44.3102 113.368Z"
              fill="#ED7D2B"
            />
            <path
              d="M53.5814 110.321C54.2438 110.169 54.6889 109.669 54.781 109.581C54.781 109.581 55.0635 109.601 54.7345 110.203C54.7068 110.253 54.646 110.382 54.5995 110.474C54.5808 110.512 54.6067 110.555 54.6487 110.558C55.0313 110.588 55.4157 110.436 56.1513 110.589C56.2532 110.611 56.2827 110.854 56.2783 110.957C56.272 111.132 56.2845 111.33 56.0807 111.598C55.9618 111.755 55.6311 111.923 54.8936 112.219C54.6129 112.332 53.8093 112.247 53.0567 111.989L52.4551 111.71L52.6419 110.594L52.793 110.625C53.0325 110.675 53.3302 110.383 53.5805 110.321H53.5814Z"
              fill="#FFB27D"
            />
            <path
              d="M38.613 93.6143C38.613 93.6143 30.1728 95.2199 41.0962 107.431C42.8429 109.384 52.2824 111.927 52.2824 111.927C52.2824 111.927 53.2398 111.113 52.7571 110.454C52.7571 110.454 46.2576 105.739 44.8282 104.99C44.1846 104.652 42.3316 97.4641 41.2831 95.7334C40.2345 94.0027 38.613 93.6143 38.613 93.6143Z"
              fill="#E3958A"
            />
            <path
              d="M54.8798 98.17C54.8798 98.17 55.156 97.6431 55.2096 97.3645C55.2633 97.0868 55.611 96.2759 55.754 96.133C55.8112 96.0759 56.0007 96.15 56.0231 96.3956C56.0329 96.5027 55.9802 96.6974 55.8872 96.9287C55.7362 97.3065 55.7612 97.8182 55.7084 97.9887C55.5779 98.4138 54.8789 98.17 54.8789 98.17H54.8798Z"
              fill="#FFB27D"
            />
            <path
              d="M1.53267 150.333H208.769C208.912 150.333 209.028 150.449 209.028 150.592V150.741C209.028 150.884 208.912 151 208.769 151H1.53267C1.38964 151 1.27344 150.884 1.27344 150.741V150.592C1.27344 150.449 1.38964 150.333 1.53267 150.333Z"
              fill="#233862"
            />
          </g>
          <defs>
            <clipPath id="clip0_1200_8075">
              <rect width="210" height="151" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    }
    default: {
      return null
    }
  }
}

Svg.defaultProps = {
  className: '',
}

Svg.propTypes = {
  type: string.isRequired,
  className: string,
}

export default Svg
